@if (true) {
<div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
        <div class="modal-content">
            <div class="modal-header BlueHeader">
                <h4 class="Heading">{{ModelFor}}</h4><br>
                <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()"
                    data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body  col-sm-12 form-group">
                <iframe width="100%" Height="400 px" frameBorder="0" [src]="modalURL|safe"></iframe>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid d-print-none">
    <div class="table-header-container">
        <div class="table-heading">
            {{TypeHeader}}
        </div>
        @if (ReportID == '201084000') {
        <div class="form-control d-print-none" >
            <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('1')" value="1"><b
                    style="color: #333;">Filed By Us</b></label>
            <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('0')" value="0"><b
                    style="color: #333;">Against Us</b></label>
            <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('2')" value="2"
                    checked><b style="color: #333;">All</b></label>
        </div>
        }
        <div class="d-flex align-items-center justify-content-end d-print-none" >
            <!-- Filter -->
            <!-- <button class="btn btn-primary mx-1" title="Advance Search" data-toggle="modal"
                (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch');" data-target="#ModalPopUP">
                <i class="material-icons text-white">filter_list</i>
                <span id="MaterialText">Filter</span>
            </button> -->
            <button class="btn btn-outline-primary " title="Advance Search" data-toggle="modal"
            (click)="OpenModal('ndc', '0', 'Filter', 'ReturnAdvanceSearch')" data-target="#ModalPopUP">
            <i class="fas fa-filter"></i>
            </button>

            <!-- Column Selection -->
             <button class="btn btn-outline-primary mx-2" title="Column Selection" data-toggle="modal"
            (click)="OpenModal('ndc','0','Column Selection','ReturnColumnSelect');" data-target="#ModalPopUP">
            <i class="fa-solid fa-list"></i>
            </button>
            <!-- <button *ngIf="this.Flow == '0'" class="btn btn-primary mx-1" title="Column Selection"
                data-toggle="modal" (click)="OpenModal('ndc','0','Column Selection','ReturnColumnSelect');"
                data-target="#ModalPopUP">
                <i class="material-icons text-white">view_column</i>
                <span class="ml-2" id="MaterialText">Column</span>
            </button> -->

            <!-- Print -->
             <button class="btn btn-outline-primary" title="Print" (click)="printReport()" ><i class="fas fa-print"></i></button>
            <!-- <button class="btn btn-primary mx-1" (click)="print()" title="Print">
                <i class="material-icons text-white">print</i>
                <span class="ml-2" id="MaterialText">Print</span>
            </button> -->

            <!-- Export Dropdown -->
            <div class="dropdown mx-1">
                <button class="btn btn-primary dropdown-toggle" id="navbarDropdown" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-download font-16 text-white"></i>
                    <span id="MaterialText" class="ml-2">Export</span>
                </button>

                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" style="color: #1C388E !important;" (click)="DownloadReport(8)">
                        <i class="fa-solid fa-file-excel font-16 "></i> Excel
                    </a>
                    <a class="dropdown-item" style="color: #1C388E !important;" (click)="DownloadReport(6)">
                        <i class="fa fa-file font-16 "></i> CSV
                    </a>
                    <!-- <a class="dropdown-item" style="color: #1C388E !important;" (click)="DownloadReport(7)">
                        <i class="fa fa-file-code font-16 "></i> HTML
                    </a> -->
                    <a class="dropdown-item" style="color: #1C388E !important;" (click)="DownloadReport(9)">
                        <i class="fa fa-file-text font-16 "></i> PDF
                    </a>
                </div>
            </div>

            <!-- Back Button -->
            <button *ngIf="showBackButton" class="btn btn-primary back-btn ml-2" title="Go Back" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back
            </button>
        </div>
    </div>
    <div class="card d-print-none" >
        <table>
            <tr *ngIf="this.MsgType == 1">
                <td colspan="80">
                    <div class="d-flex align-items-center">
                        <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                        <div class="spinner-border" role="status"></div>
                    </div>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 2">
                <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                    <span>{{DisplayMessage}}</span>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 3">
                <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                </td>
            </tr>
        </table>
    </div>
</div>

<div class="print-header">
    <div class="header-left">
        <img src="assets/images/logo-praticaone.png" alt="Logo">
    </div>

    <div class="header-center">
        <h2>Legal Management System</h2>
        <!-- <p>Legal Management System</p> -->
    </div>

    <div class="header-right">
        <p><strong>Printed By:</strong> {{printedBy}}</p>
        <p>{{printedByEmail}}</p>
        <!-- <p><strong>Date:</strong> {{printedDate}}</p> -->
    </div>
</div>

<div class="print-content" *ngIf="this.MsgType == 0">
    <div class="report-container overflow-auto" [innerHtml]="HtmlData"></div>
</div>
<div class="print-footer">
    <span class="page-number"></span>
</div>

}@else {
<my-content placeholder="navigation">
    <div class="col-sm-12" ID="ReportPrinting">
        <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>
        <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
            <div class="modal-dialog-FactSheet">
                <div class="modal-content">
                    <div class="modal-header BlueHeader">
                        <h4 class="Heading">{{ModelFor}}</h4><br>
                        <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()"
                            data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body  col-sm-12 form-group">
                        <iframe width="100%" Height="400 px" frameBorder="0" [src]="modalURL|safe"></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="this.ReportID =='207084000'" class="form-control col-sm-12"
            style="background-color: #eee; margin-left: 14px;margin-bottom: -9px; width: 98%;">
            <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('1')" value="1"><b
                    style="color: #333;">Filed By Us</b></label>
            <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('0')" value="0"><b
                    style="color: #333;">Against Us</b></label>
            <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('2')" value="2"
                    checked><b style="color: #333;">All</b></label>
            <!-- <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('3')"
                            value="2">E-Court</label> -->

        </div>
        <!-- <div class="col-sm-12" style="margin-top: 8px;">
                <div class="col-sm-12" style="background-color: #eee; border:1px solid #ccc; padding:8px;">
                    <div class="col-sm-8 reportHeading">
                        {{TypeHeader}}
                    </div>
                    <div class="col-sm-4 d-flex align-items-center justify-content-end" id="HideSubMenu">
                        <table>
                            <tr>
                                <td *ngIf="this.Flow != '0'">
                                    <div class="col-sm-12">&nbsp;</div>
                                </td>
                                <td>
                                    <div class="col-sm-12 btn btn-light">
                                        <a title="Advance Search" data-toggle="modal" (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch');" data-target="#ModalPopUP">
                                            <i class="material-icons">
                                    filter_list
                                    </i><span id="MaterialText">Filter</span></a>
                                    </div>
                                </td>
                                <td *ngIf="this.Flow == '0'">
                                    <div class="col-sm-12 btn btn-light">
                                        <a title="Column Selection" data-toggle="modal" (click)="OpenModal('ndc','0','Column Selection','ReturnColumnSelect');" data-target="#ModalPopUP"><i class="material-icons"> view_column </i><span id="MaterialText">Column</span></a></div>
                                </td>
                                <td>
                                    <div class="col-sm-12 btn btn-light" (click)="print()"><a Title="Print" ><i class="material-icons">
                                print
                                </i><span id="MaterialText">Print</span></a></div>
                                </td>
                                <td>
                                    <div class="col-sm-12 btn btn-light">
                                        <a title="Download" class=" dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fa fa-download font-16 theme-icon" aria-hidden="true"></i><span id="MaterialText">Export</span>
                                        </a>
                                        <div class="dropdown-menu" style="min-width: 100px;" aria-labelledby="navbarDropdown">
                                            <a class="dropdown-item" role="button" (click)="this.DownloadReport(8)"><i class="fa fa-file-excel-o font-16 theme-icon"></i>&nbsp; Excel</a>
                                            <a class="dropdown-item" (click)="DownloadReport(6)"><i class="fa fa-file-o font-16 theme-icon"></i> &nbsp;&nbsp; CSV</a>
                                            <a class="dropdown-item" (click)="DownloadReport(7)"><i class="fa fa-file-code-o font-16 theme-icon"></i> &nbsp;&nbsp; HTML</a>
                                            <a class="dropdown-item" (click)="DownloadReport(9)"><i class="fa fa-file-text-o font-16 theme-icon" ></i> &nbsp;&nbsp; PDF</a>
                                        </div>
                                    </div>
                                </td>
                                <td  *ngIf="showBackButton">
                                    <button class="btn btn-primary back-btn" title="Go Back" (click)="goBack()">
                                        <i class="fa fa-arrow-left"></i> Back
                                    </button>
                                </td>
                            </tr>   
                        </table>
    
                    </div>
    
                </div>
            </div> -->
        <div class="titlebar d-flex align-items-center justify-content-between mt-2">

            <!-- Left empty space (same as your reference design) -->
            <div></div>

            <!-- Center Title -->
            <div class="titlebar-text d-flex align-items-center">
                <i class="fa fa-file-text text-primary theme-icon"></i>
                <span class="ml-2 page-title">{{ TypeHeader }}</span>
            </div>

            <!-- Right Action Buttons -->
            <div class="d-flex align-items-center">

                <!-- Filter -->
                <button class="btn btn-primary mx-1" title="Advance Search" data-toggle="modal"
                    (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch');" data-target="#ModalPopUP">
                    <i class="material-icons text-white">filter_list</i>
                    <span id="MaterialText">Filter</span>
                </button>

                <!-- Column Selection -->
                <button *ngIf="this.Flow == '0'" class="btn btn-primary mx-1" title="Column Selection"
                    data-toggle="modal" (click)="OpenModal('ndc','0','Column Selection','ReturnColumnSelect');"
                    data-target="#ModalPopUP">
                    <i class="material-icons text-white">view_column</i>
                    <span class="ml-2" id="MaterialText">Column</span>
                </button>

                <!-- Print -->
                <button class="btn btn-primary mx-1" (click)="print()" title="Print">
                    <i class="material-icons text-white">print</i>
                    <span class="ml-2" id="MaterialText">Print</span>
                </button>

                <!-- Export Dropdown -->
                <div class="dropdown mx-1">
                    <button class="btn btn-primary dropdown-toggle" id="navbarDropdown" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-download font-16 text-white"></i>
                        <span id="MaterialText" class="ml-2">Export</span>
                    </button>

                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" (click)="DownloadReport(8)">
                            <i class="fa fa-file-excel-o font-16 theme-icon"></i> Excel
                        </a>
                        <a class="dropdown-item" (click)="DownloadReport(6)">
                            <i class="fa fa-file-o font-16 theme-icon"></i> CSV
                        </a>
                        <a class="dropdown-item" (click)="DownloadReport(7)">
                            <i class="fa fa-file-code-o font-16 theme-icon"></i> HTML
                        </a>
                        <a class="dropdown-item" (click)="DownloadReport(9)">
                            <i class="fa fa-file-text-o font-16 theme-icon"></i> PDF
                        </a>
                    </div>
                </div>

                <!-- Back Button -->
                <button *ngIf="showBackButton" class="btn btn-primary back-btn ml-2" title="Go Back" (click)="goBack()">
                    <i class="fa fa-arrow-left"></i> Back
                </button>

            </div>

        </div>

        <div class="col-sm-12" style="margin-top:-1px; overflow-x: scroll;">
            <table class="col-sm-12">
                <tr *ngIf="this.MsgType == 1">
                    <td colspan="80">
                        <div class="d-flex align-items-center">
                            <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                            <div class="spinner-border" role="status"></div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 2">
                    <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                        <span>{{DisplayMessage}}</span>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 3">
                    <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                    </td>
                </tr>
                <ng-container *ngIf="this.MsgType == 0">
                    <tr>
                        <div class="table-container" [innerHtml]="HtmlData"></div>
                    </tr>
                </ng-container>
            </table>

        </div>


        <div>&nbsp;<br></div>
    </div>
</my-content>
<my-content placeholder="main">
</my-content>
}